export const CONFIGURATION_PATH = "/configuration";

export const configurationParamLabel: Record<string, string> = {
  GENERAL: "Chung",
  COMMISSION_TEAM_BONUS_RATE: "Tỷ lệ thưởng đội hoa hồng SALE (%)",
  COMMISSION_CHUONG_RATE: "Tỷ lệ hoa hồng kỹ thuật HH Chương (%)",
  COMMISSION_DUNG_RATE: "Tỷ lệ hoa hồng kỹ thuật HH Dung (%)",
  COMMISSION_CHUONG_FIXED_SALARY: "Lương cố định HH Chương (đ/tháng)",
};

export const configurationDataTypeLabel: Record<string, string> = {
  STRING: "Chuỗi",
  NUMBER: "Số",
  BOOLEAN: "Đúng/Sai",
};
